import axios from "axios";
import { journal_ngrok_url } from "../bootapi";
import { supabase } from "..";

export const addJournalEntry = (formdata, token) => {
  return axios.post(`${journal_ngrok_url}/insert_journal_data`, formdata, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getGoodHabit = (user_id) => {
  return supabase.from("subs_userhabit").select().eq("user_id", user_id);
};
export const createGoodHabit = (formData) => {
  return supabase.from("subs_userhabit").insert(formData);
};
export const updateGoodHabit = (id, data) => {
  return supabase.from("subs_userhabit").update(data).eq("id", id);
};
export const deleteGoodHabit = (id) => {
  return supabase.from("subs_userhabit").delete().eq("id", id);
};
export const getGoodHabitLog = (user_id, date, enddate) => {
  return supabase
    .from("subs_userhabitlogs")
    .select()
    .eq("user_id", user_id)
    .gte("calendar_date", `${date}`)
    .lte("calendar_date", `${enddate}`);
};
export const createGoodHabitLog = (formData) => {
  return supabase.from("subs_userhabitlogs").insert(formData);
};
export const updateGoodHabitLog = (calendar_date, data) => {
  return supabase
    .from("subs_userhabitlogs")
    .update(data)
    .eq("calendar_date", calendar_date);
};
export const deleteGoodHabitLog = (id) => {
  return supabase.from("subs_userhabitlogs").delete().eq("id", id);
};

export const getJournalGoals = (user_id) => {
  return supabase.from("subs_usergoals").select().eq("user_id", user_id);
};
export const updateGoals = (id, data) => {
  return supabase.from("subs_usergoals").update(data).eq("id", id);
};
export const createGoals = (formData) => {
  return supabase.from("subs_usergoals").insert(formData);
};
export const deleteGoals = (id) => {
  return supabase.from("subs_usergoals").delete().eq("id", id);
};

export const getJournalSettings = (user_id) => {
  return supabase.from("subs_journalsettings").select().eq("user_id", user_id);
};
export const updateJournalSetting = (id, data) => {
  return supabase.from("subs_journalsettings").update(data).eq("user_id", id);
};
export const getJournalPassword = (user_id) => {
  return supabase.from("subs_journalpassword").select().eq("user_id", user_id);
};

export const getTodaySummary = (data, token) => {
  return axios.post(`${journal_ngrok_url}/today_journal_summary`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const getmoredaySummary = (data, token) => {
  return axios.post(`${journal_ngrok_url}/moredays_journal_summary`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const getJournalResources = (data, token) => {
  return axios.post(`${journal_ngrok_url}/goals_resources`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const getJournalInsights = (data, token) => {
  return axios.post(`${journal_ngrok_url}/insights`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const getJournalEntries = (user_id) => {
  return supabase.from("seventhjournal").select().eq("user_id", user_id);
};
export const getJournalStatistics = (data, token) => {
  return axios.post(`${journal_ngrok_url}/statistics`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const journalChatBot = (data, token) => {
  return axios.post(`${journal_ngrok_url}/chatqa`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const insertSettings = (formData) => {
  return supabase.from("subs_journalsettings").insert(formData);
};
export const updateJournalData = (data, token) => {
  return axios.post(`${journal_ngrok_url}/update_journal_data`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const deleteJournalEntry = (id) => {
  return supabase.from("seventhjournal").delete().eq("journal_id", id);
};
export const journalProgressTrack = (formData, token) => {
  return axios.post(`${journal_ngrok_url}/progress_tracking`, formData, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const getJournalGallery = (formData, token) => {
  return axios.post(`${journal_ngrok_url}/get_media_links`, formData, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const deleteJournalGalleryImage = (data, token) => {
  return axios.post(`${journal_ngrok_url}/delete_media_links`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const showGratitudeBox = (formData, token) => {
  return axios.post(`${journal_ngrok_url}/show_gratitude_box`, formData, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
